import React from 'react';
import { BsGithub, BsInstagram, BsLinkedin } from 'react-icons/bs';
import { FaFacebook } from 'react-icons/fa';


const SocialMedia = () => {
    return (
        <div className='app__social'>
            <a href='https://github.com/paulofersi' target='_blank'>
                <div>
                    <BsGithub />
                </div>
            </a>
            <a href='https://www.facebook.com/pfsj92/' target='_blank'>
                <div>
                    <FaFacebook />
                </div>
            </a>
            <a href='https://www.instagram.com/paulofersi/' target='_blank'>
                <div>
                    <BsInstagram />
                </div>
            </a>
            <a href='https://www.linkedin.com/in/paulo-fernandes-23b4b42b/' target='_blank'>
                <div>
                    <BsLinkedin />
                </div>
            </a>
        </div>
    )
}

export default SocialMedia